export default "__VITE_ASSET__BCo0fp_T__"